<script setup lang="ts">
const { mapVisible = false } = defineProps<{
  mapVisible?: boolean
}>()

defineEmits<{
  'toggle-filters-modal': []
  'toggle-map': []
}>()

const { filtersCount } = useSearchFiltersCount()

const openModal = ref(false)
</script>

<template>
  <div class="sticky top-0 z-fixed bg-white px-4 py-2">
    <SearchInputV2MobileContainerSummary @click="openModal = true" />

    <div class="mt-3 flex items-center gap-2">
      <button
        class="flex h-[35px] w-[125px] items-center border border-gray-200 px-3 text-md font-medium"
        type="button"
        @click="$emit('toggle-map')"
      >
        <BaseIcon :name="mapVisible ? 'picture' : 'map'" class="mr-2.5" />
        {{ mapVisible ? $t('search.listView') : $t('search.mapView') }}
      </button>
      <button
        class="flex h-[35px] items-center border border-gray-200 px-3 text-md font-medium"
        type="button"
        @click="$emit('toggle-filters-modal')"
      >
        {{ $t('search.filters') }} ({{ filtersCount }})
      </button>
    </div>
  </div>

  <BaseModalV2
    anchor="top"
    class="modal-search-input-mobile"
    :model-value="openModal"
    @back="openModal = false"
    @close="openModal = false"
  >
    <template #header="{ closeModal }">
      <div class="m-4 flex items-center justify-between">
        <span class="font-monospace text-xl font-bold">
          {{ $t('search.yourSearch') }}
        </span>
        <BaseButton
          class="!text-xs"
          color="secondary"
          variant="link"
          @click="closeModal"
        >
          {{ $t('global.close') }}
        </BaseButton>
      </div>
    </template>
    <template #content>
      <SearchInputV2MobileContainer @click-search="openModal = false" />
    </template>
  </BaseModalV2>
</template>

<style scoped>
.modal-search-input-mobile :deep(.base-modal-wrapper) {
  @apply !overflow-visible;
}
</style>
